export function Analytics(event, data) {
    window.analytics.track(event, data);
}